import { render, staticRenderFns } from "./avatar_tippy.vue?vue&type=template&id=ef6c6cc2&scoped=true&"
import script from "./avatar_tippy.vue?vue&type=script&lang=js&"
export * from "./avatar_tippy.vue?vue&type=script&lang=js&"
import style0 from "./avatar_tippy.vue?vue&type=style&index=0&id=ef6c6cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6c6cc2",
  null
  
)

export default component.exports